/**
 * @param {import("../services/project.service.types.d.ts").ActiveProject[]} projects
 * @returns {import("../services/project.service.types.d.ts").ActiveProject[]}
 **/
export const formatDropdownProjects = (projects) => {
  const sisuIntOptions = [...projects.filter((option) => !option.isBillable)]
  let restOptions = projects.filter((option) => option.isBillable)
  restOptions = restOptions.sort((a, b) => {
    if (a.clientTagName < b.clientTagName) return -1
    if (a.clientTagName > b.clientTagName) return 1
    if (a.projectTagName < b.projectTagName) return -1
    if (a.projectTagName > b.projectTagName) return 1
    return 0
  })
  return [...sisuIntOptions, ...restOptions]
}

export const formatDataTableFilterProjects = (tasks) => {
  const projects = []
  tasks?.forEach((item) => {
    let project = projects.find((project) => project.name === item?.clientName)
    if (!project) {
      project = {
        id: item?.clientID,
        name: item?.clientName,
        code: item?.clientTagName,
        isBillable: item?.isBillable,
        type: "client",
        items: [],
      }
      projects.push(project)
    }
    let projectItem = project.items.find(
      (project) => project.name === item?.projectName
    )
    if (!projectItem) {
      projectItem = {
        id: item?.projectID,
        name: item?.projectName,
        code: item?.projectTagName,
        clientCode: item?.clientTagName,
        type: "project",
      }
      project.items.push(projectItem)
    }
  })
  return projects
}
